<template>
    <div class="tw:w-full" :class="props.customClass" :data-cy="props.dataCy">
        <ValidationProvider :name="props.name" :rules="computedRules" :value="localValue" v-slot="{ errors }" mode="eager">
            <div class="tw:relative tw:w-full" :data-validation-error="errors[0] ? '' : undefined">
                <input
                    v-model="localValue"
                    type="date"
                    :name="props.name || undefined"
                    :min="props.min"
                    :max="props.max"
                    :disabled="props.disabled"
                    class="tw:block tw:p-2 tw:w-full tw:text-sm tw:rounded tw:border tw:appearance-none tw:focus:outline-none tw:peer"
                    :class="errors[0]
                        ? 'tw:border-red-500 tw:bg-red-50/50 tw:focus:border-blue-400'
                        : 'tw:border-slate-300 tw:bg-white tw:focus:border-blue-400'"
                    v-bind="$attrs"
                    @input="handleInput"
                    @change="handleChange"
                />
                <span
                    v-if="props.label"
                    class="tw:absolute tw:uppercase tw:text-xs tw:font-bold tw:tracking-wide tw:pointer-events-none tw:bg-white tw:px-2 tw:start-1 tw:top-2 tw:-translate-y-4 tw:scale-75 tw:origin-left tw:z-10"
                    :class="errors[0] ? 'tw:text-red-400' : 'tw:text-slate-600'"
                >
                    {{ props.label }}
                </span>
            </div>

            <span
                v-if="errors[0]"
                class="tw:block tw:mt-1 tw:text-xs tw:text-red-600 tw:font-medium"
            >
                {{ formatErrorMessage(errors[0]) }}
            </span>

            <span
                v-if="props.apiValidationError && !errors[0]"
                class="tw:block tw:mt-1 tw:text-xs tw:text-red-600 tw:font-medium"
            >
                {{ Array.isArray(props.apiValidationError) ? props.apiValidationError.join(', ') : props.apiValidationError }}
            </span>
        </ValidationProvider>
    </div>
</template>

<script setup>
    import { ref, computed, watch } from 'vue';

    const props = defineProps({
        label: String,
        name: String,
        rules: [String, Object],
        value: String,
        disabled: Boolean,
        min: { type: String, default: null },
        max: { type: String, default: null },
        apiValidationError: [String, Array],
        customClass: String,
        dataCy: String
    });

    const emit = defineEmits(['input', 'change']);

    const computedRules = computed(() => props.rules || '');

    const localValue = ref(props.value != null ? String(props.value) : '');

    const formatErrorMessage = err => {
        const msg = typeof err === 'string' ? err : (err && err.message) || String(err || '');
        return msg ? msg.charAt(0).toUpperCase() + msg.slice(1).toLowerCase() : '';
    };

    const handleInput = e => {
        emit('input', e.target.value);
    };

    const handleChange = e => {
        emit('change', e.target.value);
    };

    watch(() => props.value, newVal => {
        localValue.value = newVal != null ? String(newVal) : '';
    });
</script>

<script>
    export default {
        inheritAttrs: false
    };
</script>
